module.exports = __webpack_public_path__ + "static/media/35-9.1327746c.mp3";